// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_fX","advertDetailServiceList__header":"c-p_fY","advertDetailServiceList__list":"c-p_fZ"};